import { useQuery } from "@tanstack/react-query"
import { campaignCapabilitiesQuery } from "../lib/campaignCapabilitiesQuery"

export function useCampaignCapabilitiesQuery(
  ...args: Parameters<typeof campaignCapabilitiesQuery>
) {
  return useQuery(campaignCapabilitiesQuery(...args))
}
